import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Title text='Other Projects' mdxType="Title" />
    <p style={{
      color: 'gray'
    }}>
  Trends I'm following in 2019.
    </p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.brookings.edu/research/why-5g-requires-new-approaches-to-cybersecurity/"
        }}>{`Why 5G requires new approaches to cybersecurity`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://krebsonsecurity.com/2019/12/ransomware-at-colorado-it-provider-affects-100-dental-offices/"
        }}>{`Ransomware at Colorado IT Provider Affects 100+ Dental Offices`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      